import React, { useEffect, useState } from "react";
import "./check_out.css"
import { Link, BrowserRouter } from "react-router-dom";
import { TwitterTimelineEmbed, TwitterTweetEmbed } from 'react-twitter-embed';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import BlogIm1 from './BlogImages/Diginoor, Cine-NFT Marketplace bags $1 M in Seed round.jpeg'
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'
import { Instagram } from 'react-content-loader'

export default function Check_out() {
  const responsive = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
  };


  const [posts, setPosts] = useState([]);
  useEffect(() => {
    fetch('https://temp.gadgetsfresh.com/wp-json/wp/v2/posts?_embed'
    )
      .then(res => res.json())
      .then(data => {
        // console.log(data);
        setPosts(data);
      })
      .catch(err => console.log(err));

    const script = document.createElement("script");

    script.src = "//widget.tagembed.com/embed.min.js";
    script.async = true;
    script.type = "text/javascript";
    document.body.appendChild(script);
  }, []);


  setTimeout(function () {
    const display = document.getElementById("community_boxloader").style.display = "none";
    if (display == "none") {
      document.getElementById("community_boxloader").style.display = "none";
      document.getElementById("community_box").style.display = "";
    }
  }, 8000);

  //console.log(posts);

  return <div className="checkout">

    {/* heading */}
    <div className="box-head">
      <div className="box-heading">
        <p className="box-text">Check out the Diginoor community at large <span><a className="anger" href="https://linktr.ee/diginoor.io" target="_blank">follow them here</a></span>   </p>
      </div>
    </div>
    <div className="box-all social-d" id="community_boxloader">
      <div class="row">
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
      </div>
      <div class="row">
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
      </div>
      <div class="row">
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
        <div class="col-md-4"><Instagram backgroundColor={'#171630'} foregroundColor={'#141323'}/></div>
      </div>
    </div>


    <div className="box-all social-d" id="community_box" style={{ display: 'none' }}>
      <div className="box-card1">
        <TwitterTweetEmbed tweetId={'1455178355758669827'} />
      </div>


      {/* cart2 starts here */}

      <div className="box-card2">
        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="diginoor_NFT"
          options={{ height: 570 }}
        />
      </div>

      <Link to='/blog/diginoor-cine-nft-marketplace-bags-1-m-in-seed-round'>
        <div>
          <div className="box-card3">
            <img className="hp-post-img" src={BlogIm1} loading="lazy" alt="" />
            <h2>Diginoor, Cine-NFT Marketplace bags $1 M in Seed round</h2>

          </div>
        </div>
      </Link>

      {/* card 4 start here */}

      <div className="box-card4">
        <div class="tagembed-container">
          <div class="tagembed-socialwall" data-wall-id="21690" view-url="https://widget.tagembed.com/21690?view">  </div>
        </div>
      </div>



      {posts.slice(2, 3).map((post) => {

        return (
          <Link to={`/blog/${post.slug}`}>
            <div key={post.id}>
              <div className="box-card5">
                <img className="hp-post-img" loading="lazy" src={post.featured_media_src_url} alt="" />
                <h2>{post.title.rendered}</h2>
              </div>
            </div>
          </Link>
        )

      })}





      {/* car6 start here */}
      <div className="box-card6">

        <TwitterTweetEmbed
          tweetId={'1458067557177384960'} />
      </div>

      <div className="box-card7">
        <TwitterTweetEmbed
          tweetId={'1417741980415578124'}
        />
      </div>

      <div className="box-card8">
        <TwitterTweetEmbed
          tweetId={'1430473325948530690'}
        />

      </div>




      {/* card9 start here */}

      <div className="box-card9">

        <div class="tagembed-container">
          <div class="tagembed-socialwall" data-wall-id="21690" view-url="https://widget.tagembed.com/21690?view">  </div>
        </div>


      </div>
    </div>


    <div className="box-all">
      <Carousel
        responsive={responsive}
        autoPlay={true}
        autoPlaySpeed={5000}
        infinite={true}
        containerClass="social-slider"
      >
        <div className="social-cards-home">
          <TwitterTweetEmbed tweetId={'1455178355758669827'} />
        </div>
        <div className="social-cards-home">
          <TwitterTimelineEmbed sourceType="profile" screenName="diginoor_NFT" options={{ height: 570 }} />
        </div>
        <div className="social-cards-home">
          {
            posts.slice(0, 1).map((post) => {
              if (post.featured == 'yes') {
                return (
                  <Link to={`/blog/${post.slug}`}>
                    <div key={post.id}>
                      <div className="box-card3">
                        <img className="hp-post-img" src={post.featured_media_src_url} alt="" />
                        <h2>{post.title.rendered}</h2>

                      </div>
                    </div>
                  </Link>
                )
              }

            })
          }
        </div>
        <div className="social-cards-home">
          <div class="tagembed-container">
            <div class="tagembed-socialwall" data-wall-id="21690" view-url="https://widget.tagembed.com/21690?view">  </div>
          </div>
        </div>
        <div className="social-cards-home">
          {posts.slice(2, 3).map((post) => {
            if (post.featured == "") {
              return (
                <Link to={`/blog/${post.slug}`}>
                  <div key={post.id}>
                    <div className="box-card5">
                      <img className="hp-post-img" src={post.featured_media_src_url} alt="" />
                      <h2>{post.title.rendered}</h2>
                    </div>
                  </div>
                </Link>
              )
            }
          })}
        </div>
        <div className="social-cards-home">
          <TwitterTweetEmbed tweetId={'1458067557177384960'} />
        </div>
        <div className="social-cards-home">
          <TwitterTweetEmbed tweetId={'1417741980415578124'} />
        </div>
        <div className="social-cards-home">
          <TwitterTweetEmbed tweetId={'1430473325948530690'} />
        </div>
        <div className="social-cards-home">
          <div class="tagembed-container">
            <div class="tagembed-socialwall" data-wall-id="21690" view-url="https://widget.tagembed.com/21690?view">  </div>
          </div>
        </div>
      </Carousel>


    </div>




  </div>


}